/* global Popper */
import { Controller } from 'stimulus';
import { PopoverContainer } from '@/js/util';
import { PopperModifiers } from '@/js/util/popper';

const popoverContainer = PopoverContainer.tooltip('ui--tooltip-container');

export default class extends Controller {
  static targets = ['hint'];
  static values = { position: String, distance: Number, padding: Number, detached: Boolean };

  connect() {
    this.instance = null;
    this.hint = this.hintTarget;
  }

  disconnect() {
    this.#stopDetachedAutoHide();
    this.#destroyInstance();
    this.detachedValue && this.hint.remove();
  }

  show() {
    this.#visible = true;
    this.#startDetachedAutoHide();
  }

  hide() {
    this.#stopDetachedAutoHide();
    this.#visible = false;
  }

  cache() {
    this.hide();
    this.element.append(this.hint);
  }

  get #visible() {
    return !this.hint.classList.contains('hidden');
  }

  set #visible(value) {
    if (value === this.#visible) {
      return;
    }

    if (value && this.detachedValue && this.hasHintTarget) {
      this.hint = this.hintTarget.cloneNode(true);
      this.hintTarget.remove();
      this.#detach();
    }

    value ? this.#createInstance() : this.#destroyInstance();

    this.hint.classList.toggle('hidden', !value);
  }

  #detach() {
    this.dialog = this.element.closest('dialog[open]');
    this.dialog ? this.dialog.append(this.hint) : popoverContainer.add(this.hint);
  }

  #createInstance() {
    const modifiers = new PopperModifiers().offset([0, this.distanceValue]);

    if (this.paddingValue || this.dialog) {
      modifiers.preventOverflow(this.paddingValue, this.dialog);
    }

    this.instance = Popper.createPopper(this.element, this.hint, {
      placement: this.positionValue,
      modifiers: modifiers.toArray(),
    });
  }

  #destroyInstance() {
    this.instance?.destroy();
  }

  #startDetachedAutoHide() {
    this.#stopDetachedAutoHide();
    if (!this.detachedValue) {
      return;
    }

    this._autoHideHandler = (event) => {
      if (!this.element.contains(event.target)) {
        this.hide();
      }
    };
    document.addEventListener('mouseover', this._autoHideHandler);
  }

  #stopDetachedAutoHide() {
    if (this._autoHideHandler) {
      document.removeEventListener('mouseover', this._autoHideHandler);
      this._autoHideHandler = null;
    }
  }
}
